// // firebaseConfig.js
// import firebase from "firebase/compat/app";
// import "firebase/compat/firestore";
// import { getAuth } from "firebase/auth";
// import { getStorage } from "firebase/storage";

// // const firebaseConfig = {
// //   apiKey: "AIzaSyA5lBAAMgetnvS4fx9g1nqQrKhajWmAK1Q",
// //   authDomain: "blockchain-demo-bab7a.firebaseapp.com",
// //   projectId: "blockchain-demo-bab7a",
// //   storageBucket: "blockchain-demo-bab7a.appspot.com",
// //   messagingSenderId: "406716041280",
// //   appId: "1:406716041280:web:8f44e4de2d26b3c23ab7a5",
// //   databaseURL: "gs://blockchain-demo-bab7a.appspot.com",
// // };

// const firebaseConfig = {
//   apiKey: "AIzaSyATaLsyhJe8KEqyMxnfEcaHAntBzzI6FSs",
//   authDomain: "temporary-astra-products.firebaseapp.com",
//   projectId: "temporary-astra-products",
//   storageBucket: "temporary-astra-products.firebasestorage.app",
//   messagingSenderId: "601318019111",
//   appId: "1:601318019111:web:792299a2fb5b1fbbcebe02",
// };

// export const app = firebase.initializeApp(firebaseConfig);
// export const db = app.firestore();
// export const storage = getStorage(app);
// export const auth = getAuth(app);

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";

// Your Firebase config
// const firebaseConfig = {
//   apiKey: "AIzaSyATaLsyhJe8KEqyMxnfEcaHAntBzzI6FSs",
//   authDomain: "temporary-astra-products.firebaseapp.com",
//   projectId: "temporary-astra-products",
//   storageBucket: "temporary-astra-products.firebasestorage.app",
//   messagingSenderId: "601318019111",
//   appId: "1:601318019111:web:792299a2fb5b1fbbcebe02",
// };

const firebaseConfig = {
  apiKey: "AIzaSyATaLsyhJe8KEqyMxnfEcaHAntBzzI6FSs",
  authDomain: "temporary-astra-products.firebaseapp.com",
  projectId: "temporary-astra-products",
  storageBucket: "temporary-astra-products.firebasestorage.app",
  messagingSenderId: "601318019111",
  appId: "1:601318019111:web:792299a2fb5b1fbbcebe02",
  // databaseURL: "gs://blockchain-demo-bab7a.appspot.com",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);



// 🔥 v8 style exports
export const db = app.firestore();
export const db_modular = app.firestore(); // keep for your existing code
export const auth = app.auth();
export const storage = app.storage();

export default app;
